<template>
    <div ref="dialog" class="box warning-box">
        <div class="mask" @click="hide"></div>
        <div class="text">
            <div class="close" @click.stop="hide">
                <el-icon type="s-icon-zhuce-cha" :size="20" />
            </div>
            <div class="header">
                <el-icon v-if="type === 'success'" type="iconsuccess" :size="50" color="rgb(27, 185, 52)" />
                <el-icon v-else-if="type === 'error'" type="iconerror" :size="50" color="#f04040" />
                <el-icon v-else type="iconwarning" :size="50" color="#FFC000" />
            </div>
            <div class="body">{{message}}</div>
            <div class="footer">
                <el-button fixed class="w100" @click="hide">取消</el-button>
                <el-button type="primary" class="ml40 w100" @click="handleConfirm">确认</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'warning',
    data() {
        return {
            type: 'default',
            appendToBody: true,
            visible: true,
        };
    },
    'watch': {
        visible(val) {
            if (!val) {
                this.$el.remove();
            }
        }
    },
    'methods': {
        hide() {
            this.visible = false;
        },
        handleConfirm() {
            this.hide();
            this.confirm();
        },
    }
};
</script>

<style scoped lang="scss">
    .box{
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
    }
    .mask{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.3);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9;
    }
    .text{
        width:360px;
        height:300px;
        background:rgba(255,255,255,1);
        box-shadow:0px 6px 20px 0px rgba(154,167,179,0.3);
        border-radius:4px;
        position: relative;
        z-index: 10;
    }
    .close{
        display: flex;
        justify-content: center;
        align-items: center;
        width:40px;
        height:40px;
        border-radius:0px 4px 0px 0px;
        position: absolute;
        right: 0;
        top: 0;
        i{
            color: #354052;
        }
        &:hover{
            background:rgba(220,75,75,1);
            i{
                color: #fff;
            }
        }
    }
    .header{
        height: 110px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }
    .body{
        margin-top: 40px;
        font-size:14px;
        font-weight:400;
        color:rgba(53,64,82,1);
        padding: 0 20px;
        text-align: left;
        white-space:pre-wrap;
        word-break:break-all;
    }
    .footer{
        margin-top: 40px;
        text-align: center;
    }
    .w100{
        width: 100px;
    }
    .el-button+.el-button{
        margin-left: 40px;
    }
</style>
